document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-lp-mineral-ranking-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-lp-mineral-ranking-slide]'));
    if (slides.length <= 1) return;

    const dots = document.createElement('ul');
    dots.className = 'lp-mineral-ranking__dots';

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    const activateSlide = (index) => {
      activeIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });

      dots.querySelectorAll('button').forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    };

    slides.forEach((_, index) => {
      const dotItem = document.createElement('li');
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'lp-mineral-ranking__dot';
      dot.setAttribute('aria-label', `${index + 1}枚目を表示`);
      dot.addEventListener('click', () => activateSlide(index));

      dotItem.append(dot);
      dots.append(dotItem);
    });

    slider.append(dots);
    activateSlide(activeIndex);

    window.setInterval(() => {
      activateSlide((activeIndex + 1) % slides.length);
    }, 2000);
  });
});
